


import React, { useContext, useEffect, useState } from "react";
import { Tooltip } from "@mui/material";
import "react-calendar/dist/Calendar.css";
import "react-date-picker/dist/DatePicker.css";
import { Link, useNavigate } from "react-router-dom";
import { MdTrendingUp, MdTrendingDown, MdOutlineTrendingUp, MdOutlineTrendingDown } from "react-icons/md";
import NoResultFoundModel from "../NoDataFound";
import { AuthContext, LoaderContext } from "../../../Context/ContextFunctions";



import { ChangeClientStatus, GetClientList, DeleteClient } from "../../../services/Client/ClientApi";
import Android12Switch from "../AndroidSwitch";
import ProjectDetailsDialog from "./ProjectDetailsDialog";
import DonutChart from "../../charts/DonutChart";

const ActiveProjects = () => {
      const navigate = useNavigate();
      const [fromDate, setFromDate] = useState(null);
      const [toDate, setToDate] = useState(null);

      const [errorMessage, setErrorMessage] = useState(false);
      const [isErrorOpen, setIsErrorOpen] = useState(false);
      const [isAddUpdateDone, setIsAddUpdateDone] = useState(false);
      const [confirmationModal, setConfirmationModal] = useState(false);
      const [modelAction, setModelAction] = useState("");
      const [showSuccessPopupModal, setShowSuccessPopupModal] = useState(false);
      const [modelRequestData, setModelRequestData] = useState({
            KeyID: null,
            Action: null,
            status: null,
            Name: null,
            remark: null,
      });
      //List Params
      const [ClientSearch, setClientSearch] = useState("");
      const [ClientList, setClientList] = useState([]);
      const [ClientListCount, setClientListCount] = useState(-1);
      const [ClientCurrentPage, setClientCurrentPage] = useState(1);
      const [open, setOpen] = useState(false);
      //Context
      const { setLoader } = useContext(LoaderContext);
      const { authDetails, pageSize, PanalModuleName, defaultAccess } =
            useContext(AuthContext);
      //initial UseEffect
      useEffect(() => {
            GetClientListData(1, "Active");
      }, []);

      useEffect(() => {
            if (isAddUpdateDone) {
                  setClientSearch("");
                  GetClientListData(1, "Active", null);
                  setIsAddUpdateDone(false);
            }
      }, [isAddUpdateDone]);
      //Client Role List Api
      const GetClientListData = async (i, tab, searchKeyword) => {
            const pageNoList = i - 1;
            try {
                  setLoader(true);
                  let response = await GetClientList({
                        moduleName: PanalModuleName,
                        pageSize: pageSize,
                        pageNo: pageNoList,
                        searchKeyword:
                              searchKeyword === undefined ? ClientSearch : searchKeyword,
                        userKeyID: authDetails.userKeyID,
                        moduleName: tab,
                  });
                  if (response.statusCode === 200) {
                        setLoader(false);
                        const list = response.responseData?.data;
                        setClientListCount(response.totalCount);
                        setClientList(list);
                  } else {
                        setLoader(false);
                  }
            } catch (error) {
                  setLoader(false);
                  console.log(error);
            }
      };

      //Confirmation Button Click
      const handleConfirmBtn = async () => {
            setLoader(true);
            if (modelAction === "Delete") {
                  let data = await DeleteClient(
                        PanalModuleName,
                        modelRequestData.KeyID,
                        authDetails.userKeyID
                  );
                  try {
                        if (data?.statusCode === 200) {
                              setLoader(false);
                              setIsAddUpdateDone(true);
                              setConfirmationModal(false);
                              setShowSuccessPopupModal(true);
                        } else {
                              setLoader(false);
                              setConfirmationModal(false);
                              setIsErrorOpen(true);
                              const errorMessage = data?.response?.data?.errorMessage;
                              setErrorMessage(errorMessage);
                        }
                  } catch (error) {
                        setLoader(false);
                  }
            } else if (modelAction === "Status") {
                  try {
                        let data = await ChangeClientStatus(
                              PanalModuleName,
                              modelRequestData.KeyID,
                              authDetails.userKeyID
                        );
                        if (data?.statusCode === 200) {
                              setLoader(false);
                              setIsAddUpdateDone(true);
                              setConfirmationModal(false);
                              setShowSuccessPopupModal(true);
                        } else {
                              setLoader(false);
                              setIsErrorOpen(true);
                              setConfirmationModal(false);
                              const errorMessage = data?.response?.data?.errorMessage;
                              setErrorMessage(errorMessage);
                        }
                  } catch (error) {
                        setLoader(false);
                  }
            }
      };
      //Change Page Button
      const HandlePageChange = async (pageNumber) => {
            setClientCurrentPage(pageNumber);
            await GetClientListData(pageNumber, "Active"); // Call your function with the selected page number
      };

      const handleSearchFunction = (searchValue) => {
            setClientSearch(searchValue);
            GetClientListData(1, "Active", searchValue);
      };

      const handleViewClient = (client) => {
            navigate("/viewClient", {
                  state: {
                        clientKeyID: client.clientKeyID,
                        clientName: client.clientName,
                        Action: "View",
                  },
            });
      };

      return (
            <>
                  <div className="z-10 space-y-6 mx-auto rep-width mx-auto px-4">
                        <div className="h-full bg-white shadow rounded-lg flex flex-col">
                              {/* Header Section */}
                              <div
                                    style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "space-between",
                                          padding: "4px 15px",
                                    }}
                                    className="border-b p-4 overflow-x-auto"
                              >
                                    <div className="flex space-x-4">
                                          <button
                                                className={`px-4 py-2 whitespace-nowrap border-b-2 border-blue-500 text-[#135EA0] text-12`}
                                          >
                                                Active Projects List
                                          </button>
                                    </div>
                              </div>
                              <div className="p-2 border-b flex flex-wrap sm:flex-nowrap items-center justify-between gap-3">
                                    {/* Left Side: Select Dropdown */}
                                    <div></div>

                                    {/* Right Side: Search Bar & Add Button */}
                                    <div className="flex flex-wrap sm:flex-nowrap items-center w-full sm:w-auto gap-3">
                                          {/* Search Bar */}
                                          <div className="relative flex items-center w-full sm:w-64">
                                                <span className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-700"></span>
                                                <input
                                                      type="text"
                                                      className="border text-12 border-gray-200 shadow appearance-none rounded py-2 p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-sky-600 w-full"
                                                      placeholder="Search Active Projects "
                                                      value={ClientSearch}
                                                      onChange={(e) => {
                                                            handleSearchFunction(e.target.value, PanalModuleName);
                                                      }}
                                                />
                                          </div>


                                    </div>
                              </div>
                              {/* Tab Content */}
                              {/* <div className="p-4"> */}
                              <div className="flex flex-col table_wrapper border border-gray-200">
                                    <div className="flex-1 overflow-y-auto">
                                          <table className="w-full border-collapse border border-gray-200 text-12 table-auto">
                                                <thead>
                                                      <tr className="z-1 sticky top-0 bg-white">
                                                            <th className="text-12 border-b border-slate-200 bg-slate-50  whitespace-nowrap p-1"
                                                            >
                                                                  Projects Name
                                                            </th>
                                                            <th className="text-12 border-b border-slate-200 bg-slate-50  whitespace-nowrap p-1">
                                                                  Clients
                                                            </th>
                                                            <th className="text-12 border-b border-slate-200 bg-slate-50  whitespace-nowrap p-1">
                                                                  SOW(With Media)
                                                            </th>
                                                            <th className="text-12 border-b border-slate-200 bg-slate-50  whitespace-nowrap p-1">
                                                                  SLA Summary
                                                            </th>

                                                            <th className="text-12 border-b border-slate-200 bg-slate-50  whitespace-nowrap p-1">
                                                                  P&L Summary
                                                            </th>

                                                            <th className="text-12 border-b border-slate-200 bg-slate-50  whitespace-nowrap p-1">
                                                                  Payment Cycle
                                                            </th>
                                                      </tr>
                                                </thead>
                                                <tbody>
                                                      {ClientList.map((client, index) => (
                                                            <tr
                                                                  key={index}
                                                                  className="hover:bg-slate-50 border-b border-slate-200 text-center"
                                                            >
                                                                  <td className="whitespace-nowrap  px-2 py-2" onClick={() => {
                                                                        setOpen(true)
                                                                  }
                                                                  }  >
                                                                        <span className="text-blue-500 underline hover:text-blue-700">Techno Land</span>


                                                                  </td>
                                                                  <td className="whitespace-nowrap  px-2 py-2">
                                                                        Ambrish Mishra
                                                                  </td>


                                                                  <td className="whitespace-nowrap  px-2 py-2">
                                                                        Summary

                                                                  </td>
                                                                  <td className="px-2 py-2 text-center">
                                                                        <div className="w-[35px] h-[35px] mx-auto">
                                                                              <DonutChart
                                                                                    data={[
                                                                                          { name: "Completed", value: 70, color: "#4CAF50" },
                                                                                          { name: "Pending", value: 30, color: "#ff0707ff" },
                                                                                    ]}
                                                                                    showLegend={false}
                                                                                    height={100}
                                                                                    innerRadius="55%"
                                                                                    outerRadius="90%"
                                                                              />
                                                                        </div>
                                                                  </td>


                                                                  <td className="whitespace-nowrap px-2 py-2">
                                                                        <span
                                                                              style={{
                                                                                    marginLeft: "5px",
                                                                                    borderRadius: "50%",
                                                                                    color:
                                                                                          true ? "green" : true === 0 ? "orange" : "red",
                                                                                    fontWeight: 500,
                                                                                    display: "inline-flex",
                                                                                    alignItems: "center",
                                                                                    gap: "4px",
                                                                              }}
                                                                        >
                                                                              Profit
                                                                              {true ? (
                                                                                    <MdOutlineTrendingUp size={16} />
                                                                              ) : false ? (
                                                                                    <MdOutlineTrendingDown size={16} />
                                                                              ) : null}
                                                                        </span>
                                                                  </td>

                                                                  <td className="whitespace-nowrap  px-2 py-2">
                                                                        Payment Cycle
                                                                  </td>
                                                            </tr>
                                                      ))}
                                                </tbody>
                                          </table>
                                          {ClientListCount <= 0 && (
                                                <NoResultFoundModel totalRecords={ClientListCount} />
                                          )}
                                    </div>


                              </div>

                              {/* </div> */}
                        </div>
                  </div >
                  {open && (
                        <ProjectDetailsDialog
                              modelRequestData={modelRequestData}
                              setIsAddUpdateDone={setIsAddUpdateDone}
                              isOpen={open}
                              onClose={() => setOpen(false)}
                        />
                  )
                  }
            </>
      );
};

export default ActiveProjects;
